<div
  class="badge"
  [class.badge--warning]="variant() === 'warning'"
  [class.badge--success]="variant() === 'success'"
  [class.badge--error]="variant() === 'error'"
  [class.badge--info]="variant() === 'info'"
  [class.badge--date-range]="variant() === 'date-range'"
  [class.badge--category]="variant() === 'category'"
  [style.border-radius]="borderRadius()">
  <p class="badge__text">{{ label() }}</p>

  @if (deletable()) {
    <button
      class="badge__delete-btn"
      type="button"
      [disabled]="isDeleteDisabled()"
      [class.badge__delete-btn--disabled]="isDeleteDisabled()"
      [attr.aria-label]="'settings.badges.delete_aria' | translateLang"
      (click)="$event.stopPropagation(); onDelete()">
      <app-icon name="trash-outline" [size]="12" color="currentColor" aria-hidden="true" />
    </button>
  }
</div>
